var map = {
	"./amex.png": "a51b",
	"./discover.png": "e006",
	"./mastercard.png": "e541",
	"./paypal.png": "34d8",
	"./unknown.png": "0042",
	"./visa.png": "27e6",
	"./wisepoe.png": "b6fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c0e";